import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Heading, Flex, Link } from '@tq/ui-components';
import { COLOURS } from '@tq/ui-components/dist/pp2/theme';

import { PastResponse, Consultation, ConsultationResponseAnswer } from 'types';
import { Notes, NotesHeading } from 'components';
import { ArchivedRpcResponses } from '../ArchivedRpcResponses';
import { ArchivedResponsesDataTable } from '../ArchivedResponsesDataTable';
import { isRpc } from 'tools';

export const DesktopResponses: React.FC<{
  pastResponses: PastResponse[];
  pastAnswers: ConsultationResponseAnswer[];
  otherAnswers: ConsultationResponseAnswer[];
  isLoading: boolean;
  consultation?: Consultation;
}> = ({ isLoading, pastResponses, consultation, pastAnswers, otherAnswers }) => {
  const { t } = useTranslation('consultation_response');
  const [isShowingNotes, setIsShowingNotes] = useState(false);
  const notes = consultation?.notes || [];

  const notesSection = (
    <Box width={{ base: '100%', lg: '420px' }}>
      <Flex justifyContent='space-between' alignItems='center' pr={{ base: 0, lg: 5 }}>
        <>
          <NotesHeading />

          <Link fontSize='sm' onClick={() => setIsShowingNotes(false)}>
            {t('hide', 'Hide')}
          </Link>
        </>
      </Flex>
      <Box border={`1px solid ${COLOURS.gray[300]}`} mt={6} p={4}>
        <Notes notes={notes} loading={isLoading} />
      </Box>
    </Box>
  );
  const isRpcResponse = isRpc(consultation);
  return (
    <Flex
      flexDirection='row'
      justifyContent='space-between'
      gridGap={8}
      mt={6}
      data-testid='archived-responses-desktop'
    >
      <Flex grow={1} flexDirection='column'>
        <Flex
          justifyContent='space-between'
          alignItems='baseline'
          pr={{ base: 0, lg: 5 }}
          mb={4}
        >
          <Heading size='md' as='h2'>
            {t('responses', 'Responses')}
          </Heading>

          {!isShowingNotes && (
            <Link fontSize='sm' onClick={() => setIsShowingNotes(true)}>
              {t('show_notes', 'Show notes')}
            </Link>
          )}
        </Flex>
        {isRpcResponse ? (
          <ArchivedRpcResponses pastAnswers={pastAnswers} otherAnswers={otherAnswers} />
        ) : (
          <ArchivedResponsesDataTable
            consultationId={consultation?.id}
            pastResponses={pastResponses}
          />
        )}
      </Flex>
      {isShowingNotes && notesSection}
    </Flex>
  );
};
